import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { Amount } from 'src_common/common/amount/Amount';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import {
    BalanceWrapper,
    BalanceWrapperTitle,
} from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/balanceLinkNav/BalanceLinkNav.style';
import { useCommon } from 'src/domains/common/Common';
import { LocalStorageState } from 'src/domains/layouts/state/localStorage/LocalStorageState';
import { UsersState } from 'src/domains/players/state/UsersState';

export const BalanceLinkNav = observer('BalanceLinkNav', () => {
    const common = useCommon();
    const localStorageState = LocalStorageState.get(common);
    const usersState = UsersState.get(common);

    const showBalanceInHeader = localStorageState.balanceInHeader.getValue();
    const playableBalance = usersState.walletData.valueReady?.playableBalance;
    if (playableBalance === undefined) {
        return null;
    }

    const account: RightHandSideViewType = { account: 'top-up', amount: null, view: null };

    return (
        <BalanceWrapper
            dataTest='account-navigation-balance'
            routeNameForGtm='top-up'
            to={account}
        >
            <BalanceWrapperTitle>
                <I18n
                    langKey='account.navigation.balance'
                    defaultText='Balance'
                />
            </BalanceWrapperTitle>

            {showBalanceInHeader === true ? (
                <div>{usersState.money(new Amount(playableBalance))}</div>
            ) : (
                <I18n
                    langKey='account.navigation.balance.hidden'
                    defaultText='Hidden'
                />
            )}
        </BalanceWrapper>
    );
});
